/* One gentle light pass every 10 seconds. The original img is never altered, hidden or redrawn. */
(() => {
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 const start=()=>document.querySelectorAll('.hanso-amz-logo').forEach(link=>{
  const original=link.querySelector('img');
  if(!original||link.dataset.logoShine)return;
  link.dataset.logoShine='waiting';
  let firstTimer=null,repeatTimer=null,activeStop=null;
  const clearTimers=()=>{clearTimeout(firstTimer);clearInterval(repeatTimer);firstTimer=repeatTimer=null;};
  const run=()=>{
   if(activeStop)return;
   if(motion.matches){link.dataset.logoShine='static';return;}
   if(!link.isConnected){clearTimers();link.dataset.logoShine='skipped';return;}
   if(document.hidden){link.dataset.logoShine='paused';return;}
   const w=original.clientWidth,h=original.clientHeight;
   if(!w||!h){link.dataset.logoShine='static';return;}
   const overlay=document.createElement('img');
   overlay.className='hanso-logo-shine';overlay.src=original.currentSrc||original.src;
   overlay.alt='';overlay.setAttribute('aria-hidden','true');
   const box=original.getBoundingClientRect(),parent=link.getBoundingClientRect();
   // Match the full original image box. No segmentation, letter sizing or transforms.
   const oldPosition=link.style.position;
   if(getComputedStyle(link).position==='static')link.style.position='relative';
   Object.assign(overlay.style,{position:'absolute',left:`${box.left-parent.left}px`,top:`${box.top-parent.top}px`,
    width:`${w}px`,height:`${h}px`,maxWidth:'none',pointerEvents:'none',objectFit:getComputedStyle(original).objectFit,
    margin:'0',filter:'brightness(1.35)',opacity:'.5',zIndex:'1',
    maskImage:'linear-gradient(110deg,transparent 42%,black 49%,black 51%,transparent 58%)',
    maskSize:'300% 100%',maskRepeat:'no-repeat',maskPosition:'100% 0%',
    webkitMaskImage:'linear-gradient(110deg,transparent 42%,black 49%,black 51%,transparent 58%)',
    webkitMaskSize:'300% 100%',webkitMaskRepeat:'no-repeat',webkitMaskPosition:'100% 0%'});
   link.append(overlay);link.dataset.logoShine='running';
   link.dataset.logoShineCount=String(Number(link.dataset.logoShineCount||0)+1);
   link.dataset.logoShineLastStart=String(Date.now());
   const animation=overlay.animate([{maskPosition:'100% 0%',webkitMaskPosition:'100% 0%'},{maskPosition:'0% 0%',webkitMaskPosition:'0% 0%'}],{duration:1400,easing:'ease-in-out',iterations:1});
   const cleanup=()=>{overlay.remove();link.style.position=oldPosition;link.dataset.logoShine=motion.matches?'static':'complete';activeStop=null;};
   const stop=()=>{animation.cancel();cleanup();};
   activeStop=stop;animation.onfinish=cleanup;
  };
  const schedule=()=>{
   if(firstTimer!==null||repeatTimer!==null)return;
   firstTimer=setTimeout(()=>{firstTimer=null;run();repeatTimer=setInterval(run,10000);},900);
  };
  motion.addEventListener('change',()=>{if(motion.matches){activeStop?.();link.dataset.logoShine='static';}});
  document.addEventListener('visibilitychange',()=>{if(document.hidden){activeStop?.();link.dataset.logoShine='paused';}});
  window.addEventListener('pagehide',()=>{clearTimers();activeStop?.();});
  window.addEventListener('pageshow',event=>{if(event.persisted&&original.complete&&original.naturalWidth)schedule();});
  if(original.complete&&original.naturalWidth)schedule();else original.addEventListener('load',schedule,{once:true});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
